
const responseMapper = async (data) => {
    let responseMapper = []
    responseMapper = {
        code: data.code ?? '500',
        success: data.success ?? 'false',
        message: data.message === 'Ok' ? global.SUCCESS_MESSAGE_POST : data.message,
        data: data.data ?? '',
        variant: data.success ? global.VARIANT_SUCCESS : global.VARIANT_ERROR
    }
    return responseMapper
}

const successMapper = async (data, rowsTotal) => {
    let responseMapper = []
    responseMapper = {
        code: '200',
        success: 'true',
        totalRows: rowsTotal,
        message: global.SUCCESS_MESSAGE_GET,
        variant: global.VARIANT_SUCCESS,
        data: data
    }
    return responseMapper
}

const catchMapper = async (error) => {
    let responseMapper = []
    responseMapper = {
        code: '500',
        success: 'false',
        message: error,
        variant: global.VARIANT_ERROR
    }
    return responseMapper
}


const warningMapper = async (data) => {
    return {
        code: data.code ?? '400',
        success: 'false',
        message: data.message,
        variant: global.VARIANT_WARNING ?? 'warning',
        data: data.data ?? ''
    }
}


const GeneralMapper = {
    responseMapper,
    catchMapper,
    successMapper,
    warningMapper
}

export default GeneralMapper
